/**
 * @license
 * Copyright 2017 SAP Ariba
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 *
 */
import {Directive, EventEmitter, Output} from '@angular/core';


/**
 * Simple utility directive that is used by NG For cycle in situation where we need to call a
 * or execute some logic after each iteration
 */
@Directive({
    selector: '[ngForSet]'
})
export class NgForSetDirective
{

    @Output()
    onItem: EventEmitter<any> = new EventEmitter<any>();

    constructor()
    {
    }

    ngOnInit()
    {
        this.onItem.emit('--');
    }

}
